import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthenticated, logoutUser, getUserId } from '../utils/auth';
import apiClient from '../api/apiClient';

const Navbar = () => {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (isAuthenticated()) {
          const userId = getUserId();
          const response = await apiClient.get(`/api/users/v1/${userId}`);
          const user_data = response.data

          setUserData(user_data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        {isAuthenticated() ? (
          <Link to="/dashboard">Social Record News</Link>
        ) : (
          <Link to="/">Social Record News</Link>
        )}
      </div>
      
      <div className="navbar-links">
        {isAuthenticated() ? (
          <div className="user-nav-section">
            {userData && (
              <Link 
                to={`/api/users/v1/${userData.id}`} 
                className="user-profile-link"
              >
                👤 {userData.first_name}
              </Link>
            )}
              <Link 
                to="/dashboard"
              >
                Dashboard
              </Link>
            <button 
              onClick={handleLogout} 
              className="logout-button"
            >
              Sign Out
            </button>
          </div>
        ) : (
          <>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
